import React, { useMemo, useState, useCallback, useEffect } from "react";
import "./Cart.css";
import "./options-cpl.css";
import "./price-badge-cpl.css";

import NavBar from "../components/NavBar";
import Footer from "../components/Footer";
import Login from "../components/Login";
import Register from "../components/Register";
import ConfirmCommand from "../components/ConfirmCommand";
import NoLogin from "../components/NoLogin";

import { useCart } from "../CartProvider";
import { useLogin } from "../LoginProvider";
import { useNavigate } from "react-router-dom";
import { FaWhatsapp } from "react-icons/fa";

import LoadingOverlay from "./LoadingOverlay";
import ImageModal from "./ImageModal";
import LocationFeeModal from "./LocationFeeModal";
import CashPayCheckout from "./CashPayCheckout";
import PaymentHandle from "./PaymentHandle";
import Caisse from "./Caisse";
import CaisseP from "./CaisseP";
import emailjs from '@emailjs/browser';

import { useLocationFee } from "../context/LocationFeeContext";

// Firebase
import { db } from "../firebase";
import { collection, addDoc, serverTimestamp, doc, getDoc , updateDoc} from "firebase/firestore";

/* =========================
   Constantes / Helpers
========================= */

const COUNTRIES = ["Niger", "Benin"];

const STORES = [
  { id: "btq-1", name: "Cassablanca", address: "Juste a cote du cap d'essence de cassablanca" },
  { id: "btq-2", name: "Dekon", address: "En Diagonale a l'immeuble haojue de dekon." },
  { id: "btq-3", name: "Baguida", address: "Face Orabank de Baguida" },
];

const INITIAL_FORM_DATA = {
  livraison: { location: "", phone: "", fee: 0 },
  expedition: { country: "", phone: "" },
  boutique: { name: "", phone: "", store: "" },
};

const formatFCFA = (value) =>
  new Intl.NumberFormat("fr-FR", { maximumFractionDigits: 0 }).format(Number(value || 0));

const toNumber = (value) => Number(value || 0);

const genInvoiceCode = () => {
  const d = new Date();
  const pad = (n) => String(n).padStart(2, "0");
  return `${d.getFullYear()}${pad(d.getMonth() + 1)}${pad(d.getDate())}-${pad(
    d.getHours()
  )}${pad(d.getMinutes())}${pad(d.getSeconds())}`;
};

const getDiscountedUnitPrice = (product, user) => {
  const basePrice = toNumber(product?.price);

  if (!product) return 0;

  if (product.ApplyInvitation === true) {
    return basePrice * 0.9;
  }

  const userDiscount = toNumber(user?.discount);
  const itemEligible = Boolean(product?.GetDiscount);
  const maxDiscount = toNumber(product?.MaxiDiscount);

  if (userDiscount > 0 && itemEligible && maxDiscount > 0 && maxDiscount <= userDiscount) {
    return basePrice * (1 - maxDiscount / 100);
  }

  return basePrice;
};



const buildOrderItems = (items) =>
  items.map(({ product, qty }) => ({
    id: product.id,
    title: product.title,
    price: toNumber(product.price),
    qty: toNumber(qty),
    image: product.image,
    maxiDiscount: product.MaxiDiscount ?? 0,
    getDiscount: Boolean(product.GetDiscount),
    applyInvitation: Boolean(product.ApplyInvitation),
    Received: false,
    ReceivedNote: "Non Livré",
  }));

const getOptionAddressAndPhone = (option, formData) => {
  switch (option) {
    case "livraison":
      return {
        address: formData.livraison.location,
        phone: formData.livraison.phone,
        deliveryFee: toNumber(formData.livraison.fee),
      };
    case "expedition":
      return {
        address: formData.expedition.country,
        phone: formData.expedition.phone,
        deliveryFee: 0,
      };
    case "boutique":
      return {
        address: formData.boutique.store,
        phone: formData.boutique.phone,
        deliveryFee: 0,
      };
    default:
      return { address: "", phone: "", deliveryFee: 0 };
  }
};

const validateFormByOption = (option, formData) => {
  if (option === "livraison") {
    if (!formData.livraison?.location?.trim()) {
      return "Veuillez choisir votre localisation.";
    }
    if (!formData.livraison?.phone?.trim()) {
      return "Veuillez entrer votre numéro de téléphone.";
    }
    return "ok";
  }

  if (option === "expedition") {
    if (!formData.expedition?.country?.trim()) {
      return "Veuillez choisir un pays.";
    }
    if (!formData.expedition?.phone?.trim()) {
      return "Veuillez entrer votre numéro de téléphone.";
    }
    return "ok";
  }

  if (option === "boutique") {
    if (!formData.boutique?.store?.trim()) {
      return "Veuillez sélectionner une boutique.";
    }
    if (!formData.boutique?.name?.trim()) {
      return "Veuillez entrer votre nom.";
    }
    if (!formData.boutique?.phone?.trim()) {
      return "Veuillez entrer votre numéro de téléphone.";
    }
    return "ok";
  }

  return null;
};

/* =========================
   Component
========================= */

export default function Cart() {
  const navigate = useNavigate();

  const { user } = useLogin();
  const { cart, inc, dec, clear } = useCart();
  const { deliveryFee, userPos } = useLocationFee();

  const items = useMemo(() => Object.values(cart ?? {}), [cart]);

  const [loadingOverlay, setLoadingOverlay] = useState(false);
  const [showPaye, setShowPaye] = useState(false);

  const [openImage, setOpenImage] = useState(false);
  const [sourceImage, setSourceImage] = useState("");

  const [openD, setOpenD] = useState(false);
  const [selectedPay, setSelectedPay] = useState("");

  const taxe = useMemo(() => {
    return selectedPay === "cashpay" ? 2.5 : 0;
  }, [selectedPay]);

  //mail
  //mail
const sendEmail = (commande, items , delFee , FinalTotal , optionDel) => {
  // items est un tableau d’objets : [{ name, qty, price }, ...]

  // Construire les lignes du tableau
  const rows = items.map(({ product, qty }) => {
  const total = qty * product.price;
  return `
    <tr>
      <td>
        <img src="${product.image}" alt="${product.title}" width="50" height="50" style="object-fit:cover; border-radius:4px; margin-right:8px;" />
        ${product.title.slice(0 , 40)}
      </td>
      <td style="text-align:center;">${qty}</td>
      <td style="text-align:right;">${product.price} FCFA</td>
      <td style="text-align:right;">${total} FCFA</td>
    </tr>
  `;
}).join('');


  // Calculer le total global
  const grandTotal = items.reduce(
  (sum, it) => {
    const price = Number(it.product?.price ?? 0);
    const qty = Number(it.qty ?? 0);
    const base = qty * price;

    // user?.discount > 0 ?
    const userHasDiscount = (user?.discount ?? 0) > 0;

    // Où sont stockées les infos de remise ? Sur product par défaut :
    const itemEligible = Boolean(it.product?.GetDiscount); // true/false
    const percent = Number(it.product?.MaxiDiscount ?? 0); // ex: 5,10,15

    if (userHasDiscount && itemEligible && percent > 0) {
      return sum + base * (1 - percent / 100);
    }
    return sum + base;
  }, 0
);


  const templateParams = {
    name: 'DAGBA JEAN',
    user_email: 'dagbajean50@gmail.com',
    VName: 'Dollar Store',
    from_email: 'dollarstoretogo@gmail.com',
    reply_to: 'dollarstoretogo@gmail.com',
    subject: `Commande: #${commande}`,
    notes: `
      <p>Nouvelle commande sur Dollar Store :</p>
      <p>Type: ${option}</p>

      <table border="1" cellspacing="0" cellpadding="6" style="border-collapse:collapse;width:100%;font-family:sans-serif;font-size:14px;">
    <thead style="background:#f0f0f0;">
      <tr>
        <th align="left">Produit</th>
        <th align="center">Qté</th>
        <th align="right">Prix</th>
        <th align="right">Total</th>
      </tr>
    </thead>
    <tbody>
      ${rows}
    </tbody>
    <tfoot>
    <tr>
        <td colspan="3" align="right"><strong>Sous Total :</strong></td>
        <td align="right"><strong>${grandTotal} FCFA</strong></td>
      </tr>
      <tr>
        <td colspan="3" align="right"><strong>Livraison :</strong></td>
        <td align="right"><strong>${delFee} FCFA</strong></td>
      </tr>
      <tr>
        <td colspan="3" align="right"><strong>Total global :</strong></td>
        <td align="right"><strong>${FinalTotal} FCFA</strong></td>
      </tr>
    </tfoot>
  </table>
    `,
  };

  if (!/\S+@\S+\.\S+/.test(templateParams.user_email)) {
    console.error('Adresse destinataire invalide');
    return;
  }

  emailjs
    .send('service_iwp21zr', 'template_qllf7xk', templateParams, 'wMCBY4g_tRljJp2SS')
    .then((res) => console.log('Email envoyé !', res.status, res.text))
    .catch((err) => console.log("Erreur lors de l'envoi de l'email.", err?.text || err));
};

//whatsapp


  const [authModal, setAuthModal] = useState(null);
  const [openConfirm, setOpenConfirm] = useState(false);
  const [openConfirmNC, setOpenConfirmNC] = useState(false);

  const [option, setOption] = useState(null);
  const [formData, setFormData] = useState(INITIAL_FORM_DATA);

  const [getStatus, setGetStatus] = useState(0);
  const [getCommande, setGetCommande] = useState("");
  const [getPrice, setGetPrice] = useState(0);
  const [getRealPrice, setGetRealPrice] = useState(0);
  const [getOption, setGetOption] = useState("");
  const [getOptionPrice, setGetOptionPrice] = useState(0);
  const [stockWarning, setStockWarning] = useState("");

  const [isHover, setIsHover] = useState(false);

  const checkCassablancaStock = useCallback(async () => {
    try {
      const errors = [];

      for (const { product, qty } of items) {
        const productRef = doc(db, "items", String(product.id));
        const productSnap = await getDoc(productRef);

        if (!productSnap.exists()) {
          errors.push(`- ${product.title} : produit introuvable`);
          continue;
        }

        const productData = productSnap.data();
        const availableQty = Number(productData?.Stores?.Cassablanca?.Quantity ?? 0);
        const requestedQty = Number(qty ?? 0);

        if (availableQty < requestedQty) {
          errors.push(`- ${product.title} : Demandé ${requestedQty}, Disponible ${availableQty}`);
        }
      }

      if (errors.length > 0) {
        setStockWarning(
          `Stock insuffisant pour certains produits ( Supprimer les du panier pour continuer ) :\n${errors.join(
            "\n"
          )}`
        );
        return false;
      }

      setStockWarning("");
      return true;
    } catch (error) {
      console.error("Erreur lors de la vérification du stock :", error);
      setStockWarning("Impossible de vérifier le stock avant validation.");
      return false;
    }
  }, [items]);

  useEffect(() => {
    document.title = "Panier de commandes";
  }, []);

  useEffect(() => {
    window.scrollTo({ top: 0, behavior: "smooth" });
  }, [items.length]);

  useEffect(() => {
    if (option !== "livraison") return;
    if (!userPos?.label) return;

    setFormData((prev) => ({
      ...prev,
      livraison: {
        ...prev.livraison,
        location: userPos.label,
        fee: toNumber(deliveryFee),
      },
    }));
  }, [option, userPos, deliveryFee]);

  const closeAuthModal = () => setAuthModal(null);
  const switchToAuthModal = (target) => setAuthModal(target);

  const invitationDiscountTotal = useMemo(() => {
    return items.reduce((sum, it) => {
      if (it.product?.ApplyInvitation === true) {
        const price = toNumber(it.product?.price);
        const qty = toNumber(it.qty);
        return sum + price * qty * 0.1;
      }
      return sum;
    }, 0);
  }, [items]);

  const totalQty = useMemo(() => {
    return items.reduce((sum, it) => sum + toNumber(it.qty), 0);
  }, [items]);

  const totalPriceBefore = useMemo(() => {
    return items.reduce((sum, it) => {
      const price = toNumber(it.product?.price);
      const qty = toNumber(it.qty);
      return sum + price * qty;
    }, 0);
  }, [items]);

  const totalPrice = useMemo(() => {
    return items.reduce((sum, it) => {
      const qty = toNumber(it.qty);
      const unitPrice = getDiscountedUnitPrice(it.product, user);
      return sum + unitPrice * qty;
    }, 0);
  }, [items, user]);

  const selectedFee = useMemo(() => {
    if (option !== "livraison") return 0;
    return toNumber(formData.livraison.fee ?? deliveryFee ?? 0);
  }, [option, formData.livraison.fee, deliveryFee]);

  const taxesAmount = useMemo(() => {
    return Math.round((toNumber(totalPrice) + toNumber(selectedFee)) * (taxe / 100));
  }, [totalPrice, selectedFee, taxe]);

  const grandTotal = useMemo(() => {
    return toNumber(totalPrice) + toNumber(selectedFee) + toNumber(taxesAmount);
  }, [totalPrice, selectedFee, taxesAmount]);

  const isDisabled = useMemo(() => {
    const validationResult = validateFormByOption(option, formData);

    return !selectedPay || validationResult !== "ok" || items.length === 0;
  }, [selectedPay, option, formData, items.length]);

  const handleChangeLocation = useCallback((group, field, value) => {
    setFormData((prev) => {
      if (group === "livraison" && field === "location") {
        return {
          ...prev,
          livraison: {
            ...prev.livraison,
            location: value,
          },
        };
      }

      return {
        ...prev,
        [group]: {
          ...prev[group],
          [field]: value,
        },
      };
    });
  }, []);

  const handlePayment = useCallback(
  async (total, invoice, id) => {
    setShowPaye(true);

    try {
      const response = await fetch("/api/cashpay-create-order", {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify({
          amount: total,
          currency: "XOF",
          description: `Paiement Commande #${invoice}`,
          reference: id,
          client: {
            lastname: user?.name || "CLIENT",
            firstname: user?.name || "CLIENT",
            phone: user?.phone || "+22890000000",
          },
          orderId: id,
        }),
      });

      const data = await response.json();

      if (!response.ok) {
        throw new Error(data?.error || "Erreur lors de la création du paiement.");
      }

      const paymentUrl =
        data?.bill_url ||
        data?.long_bill_url ||
        data?.data?.bill_url ||
        data?.data?.long_bill_url ||
        data?.data?.redirect_url;

      if (!paymentUrl) {
        throw new Error("Aucune URL de paiement retournée par CashPay.");
      }

      try {
        await updateDoc(doc(db, "ecom_orders", id), {
          PaymentData: {
            success: data?.success ?? null,
            orderId: data?.orderId ?? null,
            reference: data?.reference ?? null,
            amount: data?.data?.amount ?? null,
            currency: data?.data?.currency ?? "XOF",
            status: data?.data?.status ?? null,
            code: data?.data?.code ?? null,
            bill_url: data?.data?.bill_url ?? null,
            redirect_url: data?.data?.redirect_url ?? null,
            callback_url: data?.data?.callback_url ?? null,
            date_create: data?.data?.date_create ?? null,
            date_expiration: data?.data?.date_expiration ?? null,
            description: data?.data?.description ?? null,
            raw_id: data?.data?.id ?? null,
            order_reference: data?.data?.order_reference ?? null,
            merchant_reference: data?.data?.merchant_reference ?? null,
            state: data?.data?.state ?? null,
            message: data?.data?.message ?? null,
          },
        });
      } catch (e) {
        console.error("Erreur :");
      }

      window.location.href = paymentUrl;
    } catch (error) {
      //console.error("Payment error:", error);
      alert("Impossible d'initialiser le paiement...Contacter le service client: +228 90 04 59 26");
    } finally {
      setShowPaye(false);
    }
  },
  [user]
);

  // const handlePayment = useCallback(
  //   async (total, invoice, id) => {
  //     setShowPaye(true);

  //     try {
  //       const response = await fetch("/api/cashpay-create-order", {
  //         method: "POST",
  //         headers: {
  //           "Content-Type": "application/json",
  //         },
  //         body: JSON.stringify({
  //           amount: total,
  //           currency: "XOF",
  //           description: `Paiement Commande #${invoice}`,
  //           reference: id,
  //           client: {
  //             lastname: user?.name || "CLIENT",
  //             firstname: user?.name || "CLIENT",
  //             phone: user?.phone || "+22890000000",
  //           },
  //           orderId: id,
  //         }),
  //       });

  //       const data = await response.json();

  //       console.log("cashpay-create-order status:", response.status);
  //       console.log("cashpay-create-order data:", data);

  //       if (!response.ok) {
  //         throw new Error(data?.error || "Erreur lors de la création du paiement.");
  //       }

  //       const paymentUrl = data.bill_url || data.long_bill_url;

  //       if (!paymentUrl) {
  //         throw new Error("Aucune URL de paiement retournée par CashPay.");
  //       }

  //       window.location.href = paymentUrl;
  //     } catch (error) {
  //       console.error("Payment error:", error);
  //       alert("Impossible d'initialiser le paiement.");
  //     } finally {
  //       setShowPaye(false);
  //     }
  //   },
  //   [user]
  // );

  const buildOrderDoc = useCallback(
    ({
      isGuest,
      invoiceCode,
      total,
      deliveryFeeValue,
      taxes,
      deliveryAddress,
      deliveryPhone,
      selectedPay,
    }) => {
      const orderItems = buildOrderItems(items);
      const remise = toNumber(totalPriceBefore) - toNumber(totalPrice);

      const searchKeywords = [
      invoiceCode,
      user?.name || "CLIENT",
      isGuest ? "Anonyme" : user?.phone || "",
      isGuest ? "Anonyme" : user?.phone || "",
      isGuest ? invoiceCode : user?.id,
      deliveryAddress,
      selectedPay === "caisse" ? "CAISSE" : "CASHPAY",
      option,
    ]
      .filter(Boolean)
      .map((v) => String(v).toLowerCase().trim());

      return {
        code: invoiceCode,
        uid: isGuest ? invoiceCode : user?.id,
        Paid: false,
        Channel: selectedPay === "caisse" ? "CAISSE" : "CASHPAY",
        Taxe: taxe,
        TaxeFee: taxes,
        name: isGuest
          ? option === "boutique"
            ? formData.boutique.name || "Anonyme"
            : "Anonyme"
          : user?.name || "",
        phone_user: isGuest ? "Anonyme" : user?.phone || "",
        Adresse: deliveryAddress,
        DeliveryFee: deliveryFeeValue,
        Telephone: deliveryPhone,
        Etat: selectedPay === "caisse" ? "create" : "create",
        UserDiscount: isGuest ? 0 : toNumber(user?.discount),
        TotalQty: totalQty,
        TotalPrice: totalPrice,
        RemisePrice: remise,
        AfterTotal: total,
        Option: option,
        OrdersItems: orderItems,
        createdAt: serverTimestamp(),
        BillFees: invitationDiscountTotal || 0,
        searchKeywords: searchKeywords
      };
    },
    [
      items,
      totalPriceBefore,
      totalPrice,
      taxe,
      user,
      totalQty,
      option,
      formData.boutique.name,
      invitationDiscountTotal,
    ]
  );

  const createAndPayOrder = useCallback(
  async (isGuest = false) => {
    setStockWarning("");

    if (!isGuest && !user) {
      alert("Veuillez vous connecter.");
      return;
    }

    if (items.length === 0) {
      alert("Votre panier est vide.");
      return;
    }

    if (!selectedPay) {
      alert("Veuillez choisir un mode de paiement.");
      return;
    }

    const validationResult = validateFormByOption(option, formData);
    if (validationResult !== "ok") {
      alert(validationResult || "Veuillez remplir correctement le formulaire.");
      return;
    }

    setLoadingOverlay(true);

    try {
      const stockOk = await checkCassablancaStock();
      if (!stockOk) {
        setLoadingOverlay(false);
        window.scrollTo({
          top: 0,
          behavior: "smooth",
        });
        return;
      }

      const {
        address,
        phone,
        deliveryFee: deliveryFeeValue,
      } = getOptionAddressAndPhone(option, formData);

      const invoiceCode = genInvoiceCode();
      const taxes = Math.round(
        (toNumber(totalPrice) + toNumber(deliveryFeeValue)) * (taxe / 100)
      );
      const finalTotal =
        toNumber(totalPrice) + toNumber(deliveryFeeValue) + toNumber(taxes);

      const orderDoc = buildOrderDoc({
        isGuest,
        invoiceCode,
        total: finalTotal,
        deliveryFeeValue,
        taxes,
        deliveryAddress: address,
        deliveryPhone: phone,
        selectedPay,
      });

      const docRef = await addDoc(collection(db, "ecom_orders"), orderDoc);

      setGetCommande(invoiceCode);
      setGetPrice(totalPrice);
      setGetRealPrice(finalTotal);
      setGetOption(option);
      setGetOptionPrice(deliveryFeeValue);

      if (selectedPay === "caisse") {
        setGetStatus(1);
        setLoadingOverlay(false);

        await sendEmail(invoiceCode, items , deliveryFeeValue , finalTotal , option);

        // const dates = new Date().toLocaleDateString();
        // const customerName = isGuest
        //   ? option === "boutique"
        //     ? formData.boutique.name || "Client"
        //     : "Client"
        //   : user?.name || "Client";

        // const customerPhone = isGuest
        //   ? phone || "Non renseigné"
        //   : user?.phone || phone || "Non renseigné";

        // const message = `*❗❗❗ Nouvelle commande !❗❗❗*\nClient ${customerName} - ${customerPhone} est entrain de préparer une commande (Contactez le pour plus d'informations) : *${invoiceCode}*\nTotal : *${finalTotal} FCFA*\nDate : ${dates}\nType: ${option}`;

        // const res = await fetch("/api/send-whatsapp", {
        //   method: "POST",
        //   headers: { "Content-Type": "application/json" },
        //   body: JSON.stringify({
        //     to: "+22890045926",
        //     text: message,
        //   }),
        // });

        // const data = await res.json();

        // if (!res.ok) {
        //   throw new Error(data?.error || "Échec envoi WhatsApp");
        // }

        //console.log("✅ Message envoyé :", data.sid);

        clear();
        return;
      }

      setLoadingOverlay(false);
      // const dates = new Date().toLocaleDateString();
      //   const customerName = isGuest
      //     ? option === "boutique"
      //       ? formData.boutique.name || "Client"
      //       : "Client"
      //     : user?.name || "Client";

      //   const customerPhone = isGuest
      //     ? phone || "Non renseigné"
      //     : user?.phone || phone || "Non renseigné";

      //   const message = `*Nouvelle commande !*\nClient ${customerName} - ${customerPhone} vient d'initier une commande : *${invoiceCode}*\nTotal : *${finalTotal} FCFA*\nDate : ${dates}\nType: ${option}`;

      //   const res = await fetch("/api/send-whatsapp", {
      //     method: "POST",
      //     headers: { "Content-Type": "application/json" },
      //     body: JSON.stringify({
      //       to: "+22890045926",
      //       text: message,
      //     }),
      //   });

      //   const data = await res.json();

      //   if (!res.ok) {
      //     throw new Error(data?.error || "Échec envoi WhatsApp");
      //   }

        //console.log("✅ Message envoyé :", data.sid);
      await handlePayment(finalTotal, invoiceCode, docRef.id);
    } catch (error) {
      console.error("saveOrder error:", error);
      setLoadingOverlay(false);
    }
  },
  [
    user,
    items,
    selectedPay,
    option,
    formData,
    totalPrice,
    taxe,
    buildOrderDoc,
    handlePayment,
    checkCassablancaStock,
    clear,
  
  ]
);

  const handleConfirm = useCallback(() => {
    if (!user) {
      setAuthModal("login");
      return;
    }

    if (items.length === 0) {
      alert("Votre panier est vide.");
      return;
    }

    setOpenConfirm(true);
  }, [user, items.length]);

  const handleConfirmNC = useCallback(() => {
    if (items.length === 0) {
      alert("Votre panier est vide.");
      return;
    }

    setOpenConfirmNC(true);
  }, [items.length]);

  const renderCartLine = ({ product, qty }) => {
    const basePrice = toNumber(product.price);
    const discountedUnit = getDiscountedUnitPrice(product, user);
    const lineTotal = discountedUnit * toNumber(qty);
    const isInvitation = product?.ApplyInvitation === true;
    const hasDiscountBadge =
      !isInvitation &&
      toNumber(user?.discount) > 0 &&
      product?.GetDiscount === true &&
      toNumber(product?.MaxiDiscount) > 0 &&
      toNumber(product?.MaxiDiscount) <= toNumber(user?.discount);

    return (
      <div className="cart-line-cart" key={product.id}>
        <div className="cart-line-left-cart">
          <div className="cart-thumb-cart">
            <img
              src={product.image}
              alt={product.title}
              onClick={() => {
                setSourceImage(product.image);
                setOpenImage(true);
              }}
            />
          </div>

          <div className="cart-line-info-cart">
            <p className="cart-item-title-cart"></p>
            <p className="cart-meta-cart">{formatFCFA(basePrice)} FCFA</p>
            <p className="cart-meta-cart">
              {product.title?.slice(0, 30)}
              {product.title?.length > 30 ? "..." : ""}
            </p>

            {window.innerWidth <= 900 && (
              <div className="cart-line-right-cart">
                <div className="cart-line-price-cart">{formatFCFA(lineTotal)} FCFA</div>
                <div className="cart-qty-cart">
                  <button onClick={() => dec(product.id)} aria-label="Decrease">
                    −
                  </button>
                  <span>{qty}</span>
                  <button onClick={() => inc(product.id, product.stock)} aria-label="Increase">
                    +
                  </button>
                </div>
              </div>
            )}

            <div className="cart-actions-row-cart">
              {isInvitation && (
                <div className="price-badge-cpl">
                  <div className="price-row-cpl">
                    Prix : <strong>{formatFCFA(basePrice)} FCFA</strong>
                  </div>
                  <div className="discount-row-cpl">
                    Remise spéciale : <span className="discount-value-cpl">10%</span>
                  </div>
                </div>
              )}

              {hasDiscountBadge && (
                <div className="price-badge-cpl">
                  <div className="price-row-cpl">
                    Prix : <strong>{formatFCFA(basePrice)} FCFA</strong>
                  </div>
                  <div className="discount-row-cpl">
                    Remise : <span className="discount-value-cpl">{product.MaxiDiscount}%</span>
                  </div>
                </div>
              )}

              {!isInvitation && toNumber(user?.discount) > 0 && product?.GetDiscount !== true && (
                <div className="price-badge-cpl">
                  <div className="discount-row-cpl">
                    Déjà en promotion, remise non applicable.
                  </div>
                </div>
              )}
            </div>
          </div>
        </div>

        {window.innerWidth > 900 && (
          <div className="cart-line-right-cart">
            <div className="cart-line-price-cart">{formatFCFA(lineTotal)} FCFA</div>
            <div className="cart-qty-cart">
              <button onClick={() => dec(product.id)} aria-label="Decrease">
                −
              </button>
              <span>{qty}</span>
              <button onClick={() => inc(product.id, product.stock)} aria-label="Increase">
                +
              </button>
            </div>
          </div>
        )}
      </div>
    );
  };

  const renderReceptionForm = () => (
    <div className="container-cpl">
      <form className="form-wrap-cpl">
        <fieldset className="radio-group-cpl">
          <legend className="legend-cpl">
            Mode de réception
            <span
              className="payment-status"
              style={{
                display: "block",
                marginBottom: 14,
                fontSize: 14,
                color: "#666",
                textAlign: "left",
              }}
            >
              (Sélectionnez une option) <span style={{ color: "red" }}>*</span>
            </span>
          </legend>

          <label
            className={`radio-item-cpl ${option === "livraison" ? "active-cpl" : ""}`}
            onClick={() => {
              setOption("livraison");
              setOpenD(true);
            }}
          >
            <input
              type="radio"
              name="mode"
              value="livraison"
              checked={option === "livraison"}
              onChange={() => setOption("livraison")}
              className="radio-input-cpl"
            />
            <span className="radio-label-cpl">Livraison</span>

            {option === "livraison" && (
              <button
                type="button"
                className="change-location-btn"
                onClick={(e) => {
                  e.stopPropagation();
                  setOpenD(true);
                }}
              >
                Choisir localisation
              </button>
            )}
          </label>

          <label className={`radio-item-cpl ${option === "expedition" ? "active-cpl" : ""}`}>
            <input
              type="radio"
              name="mode"
              value="expedition"
              checked={option === "expedition"}
              onChange={() => setOption("expedition")}
              className="radio-input-cpl"
            />
            <span className="radio-label-cpl">Expédition</span>
          </label>

          <label className={`radio-item-cpl ${option === "boutique" ? "active-cpl" : ""}`}>
            <input
              type="radio"
              name="mode"
              value="boutique"
              checked={option === "boutique"}
              onChange={() => setOption("boutique")}
              className="radio-input-cpl"
            />
            <span className="radio-label-cpl">Récupérer</span>
          </label>
        </fieldset>

        <div className="panel-cpl">
          {option === "livraison" && (
            <>
              <br />
              <div className="grid-cpl">
                <div className="field-cpl">
                  <label htmlFor="livraison-location" className="label-cpl">
                    Localisation
                  </label>
                  <input
                    type="text"
                    id="livraison-location"
                    className="input-cpl"
                    placeholder="Cliquer ici pour saisir votre localisation"
                    value={formData.livraison.location}
                    onChange={(e) =>
                      handleChangeLocation("livraison", "location", e.target.value)
                    }
                    required
                    disabled
                  />
                </div>

                <div className="field-cpl">
                  <label htmlFor="livraison-phone" className="label-cpl">
                    Téléphone
                  </label>
                  <input
                    id="livraison-phone"
                    className="input-cpl"
                    type="tel"
                    inputMode="tel"
                    placeholder="+228 90 00 00 00"
                    value={formData.livraison.phone}
                    onChange={(e) => handleChangeLocation("livraison", "phone", e.target.value)}
                    pattern="^\+?\d[\d\s\-()]{6,}$"
                    required
                  />
                </div>
              </div>
              <br />
              <span style={{ color: "red", fontSize: 13, fontWeight: 600 , marginTop: 52}}>
                {formData.livraison.phone !== "" ? "" : "Entrez votre numéro de telephone."}
              </span>
            </>
          )}

          {option === "expedition" && (
            <>
              <br />
              
              <div className="grid-cpl">
                <div className="field-cpl">
                  <label htmlFor="expedition-country" className="label-cpl">
                    Pays
                  </label>
                  <select
                    id="expedition-country"
                    className="input-cpl"
                    value={formData.expedition.country}
                    onChange={(e) =>
                      handleChangeLocation("expedition", "country", e.target.value)
                    }
                    required
                  >
                    <option value="">— Sélectionner —</option>
                    {COUNTRIES.map((country) => (
                      <option key={country} value={country}>
                        {country}
                      </option>
                    ))}
                  </select>
                </div>

                <div className="field-cpl">
                  <label htmlFor="expedition-phone" className="label-cpl">
                    Téléphone
                  </label>
                  <input
                    id="expedition-phone"
                    className="input-cpl"
                    type="tel"
                    inputMode="tel"
                    placeholder="+229 12 34 56 78"
                    value={formData.expedition.phone}
                    onChange={(e) => handleChangeLocation("expedition", "phone", e.target.value)}
                    pattern="^\+?\d[\d\s\-()]{6,}$"
                    required
                  />
                </div>
              </div><br />

              <span style={{ color: "red", fontSize: 13, fontWeight: 600 , marginTop: 52}}>
                d&apos;autres frais peuvent s&apos;appliquer ( en fonction de votre colis)
              </span>
            </>
          )}

          {option === "boutique" && (
            <>
              <br />
              <div className="grid-cpl">
                <div className="field-cpl">
                  <label htmlFor="boutique-store" className="label-cpl">
                    Boutique de retrait
                  </label>
                  <select
                    id="boutique-store"
                    className="input-cpl"
                    value={formData.boutique.store}
                    onChange={(e) => handleChangeLocation("boutique", "store", e.target.value)}
                    required
                  >
                    <option value="">— Sélectionner —</option>
                    {STORES.map((store) => (
                      <option key={store.id} value={store.name}>
                        {store.name}
                      </option>
                    ))}
                  </select>
                </div>

                <div className="field-cpl">
                  <label htmlFor="boutique-name" className="label-cpl">
                    Nom
                  </label>
                  <input
                    id="boutique-name"
                    className="input-cpl"
                    type="text"
                    placeholder="Nom et prénom"
                    value={formData.boutique.name}
                    onChange={(e) => handleChangeLocation("boutique", "name", e.target.value)}
                    required
                  />
                </div>

                <div className="field-cpl">
                  <label htmlFor="boutique-phone" className="label-cpl">
                    Téléphone
                  </label>
                  <input
                    id="boutique-phone"
                    className="input-cpl"
                    type="tel"
                    inputMode="tel"
                    placeholder="90 00 00 00"
                    value={formData.boutique.phone}
                    onChange={(e) => handleChangeLocation("boutique", "phone", e.target.value)}
                    pattern="^\+?\d[\d\s\-()]{6,}$"
                    required
                  />
                </div>
              </div><br />

              <span style={{ color: "red", fontSize: 13, fontWeight: 600 , marginTop: 52}}>
                Communiquer le numero de la commande à la personne qui passera recupérer.
              </span>
            </>
          )}
        </div>
      </form>
    </div>
  );

  return (
    <>
      <NavBar />

      <section className="cart-wrap-cart">
        {getStatus === 0 && (
          <h1 className="cart-title-cart">
            {items.length > 0 ? "Votre Panier" : "Oups!!! Votre panier est vide."}
          </h1>
        )}

        {stockWarning && (
          <div className="stock-warning-box">
            <strong>Attention :</strong>
            <pre className="stock-warning-text">{stockWarning}</pre>
          </div>
        )}

        {getStatus === 1 && (
          <h1 className="cart-title-cart">
            <br />
          </h1>
        )}

        {getStatus === 0 ? (
          <div className="cart-layout-cart">
            {items.length > 0 ? (
              <div className="cart-left-cart">
                <div className="cart-card-cart">
                  {items
                    .filter(({ product }) => product?.ApplyInvitation === true)
                    .map(renderCartLine)}

                  {items
                    .filter(({ product }) => product?.ApplyInvitation !== true)
                    .map(renderCartLine)}

                  <div className="cart-card-foot-cart">
                    <button className="cart-reset-cart" onClick={clear}>
                      Vider le panier
                    </button>
                  </div>
                </div>
              </div>
            ) : (
              <div className="cart-left-cart">
                <div className="cart-card-cart">
                  <div className="cart-line-cart">
                    <div className="cart-line-left-cart">
                      <img src="/images/empty.gif" alt="empty cart" />
                    </div>
                    <div className="cart-line-right-cart" />
                  </div>

                  <div className="cart-card-foot-cart">
                    <p>Ajoutez des produits pour confirmer votre commande</p>
                    <button className="cart-checkout-cart" onClick={() => navigate("/products")}>
                      Commencer les achats
                    </button>
                  </div>
                </div>
              </div>
            )}

            {items.length > 0 &&
              (user?.name ? (
                <aside className="cart-summary-cart">
                  <div className="cart-summary-box-cart">
                    <h3 className="cart-subhead-cart">Résumé de la commande</h3>

                    <div className="cart-row-cart">
                      <span>Produits</span>
                      <span style={{ fontWeight: "bold" }}>{totalQty}</span>
                    </div>

                    <div className="cart-row-cart">
                      <span>Sous Total</span>
                      <span style={{ fontWeight: "bold" }}>
                        {formatFCFA(totalPriceBefore)} FCFA
                      </span>
                    </div>

                    <div className="cart-row-cart">
                      <span>Livraison</span>
                      <span>{formatFCFA(selectedFee)} FCFA</span>
                    </div>

                    <div className="cart-row-cart">
                      <span>Remise</span>
                      <span style={{ fontWeight: "bold" }}>
                        {formatFCFA(totalPriceBefore - totalPrice)} FCFA
                      </span>
                    </div>

                    <hr className="cart-rule-cart" />

                    <div className="cart-row-cart">
                      <span style={{ fontWeight: "bold", fontSize: 22 }}>Taxe</span>
                      <span style={{ fontWeight: "bold", color: "#dc3545", fontSize: 19 }}>
                        {formatFCFA(taxesAmount)} FCFA
                      </span>
                    </div>

                    <hr className="cart-rule-cart" />

                    <div className="cart-row-cart cart-total-row-cart">
                      <span>Total à payer</span>
                      <strong>{formatFCFA(grandTotal)} FCFA</strong>
                    </div>

                    {renderReceptionForm()}

                    <CashPayCheckout
                      amount={grandTotal}
                      description="Paiement facture"
                      disabled={isDisabled}
                      selectedPay={selectedPay}
                      setSelectedPay={setSelectedPay}
                    />

                    {selectedPay === "caisse" ? <Caisse /> : null}
                    {selectedPay === "cashpay" ? <CaisseP /> : null}

                    <button
                      className="cart-checkout-cart"
                      disabled={isDisabled}
                      onClick={handleConfirm}
                      onMouseEnter={() => !isDisabled && setIsHover(true)}
                      onMouseLeave={() => setIsHover(false)}
                      style={{
                        background: isDisabled ? "#ccc" : isHover ? "#219150" : "#27ae60",
                        color: "#fff",
                        opacity: isDisabled ? 0.6 : 1,
                        cursor: isDisabled ? "not-allowed" : "pointer",
                        transition: "all 0.2s ease",
                      }}
                    >
                      {selectedPay === "caisse"
                        ? "Enregistrer la commande"
                        : "Payez ma commande"}
                    </button>
                  </div>
                </aside>
              ) : (
                <aside className="cart-summary-cart">
                  <div className="cart-summary-box-cart">
                    <h3 className="cart-subhead-cart">Résumé de votre commande</h3>
                    <p style={{ textAlign: "left" }}>Rapide, simple et efficace.</p>

                    <div className="cart-row-cart">
                      <span>Produits</span>
                      <span style={{ fontWeight: "bold" }}>{totalQty}</span>
                    </div>

                    <div className="cart-row-cart">
                      <span>Total</span>
                      <span style={{ fontWeight: "bold" }}>{formatFCFA(totalPrice)} FCFA</span>
                    </div>

                    <div className="cart-row-cart">
                      <span>Livraison</span>
                      <span>{formatFCFA(selectedFee)} FCFA</span>
                    </div>

                    <hr className="cart-rule-cart" />

                    <div className="cart-row-cart">
                      <span style={{ fontWeight: "bold", fontSize: 22 }}>Taxe</span>
                      <span style={{ fontWeight: "bold", color: "#dc3545", fontSize: 19 }}>
                        {formatFCFA(taxesAmount)} FCFA
                      </span>
                    </div>

                    <hr className="cart-rule-cart" />

                    <div className="cart-row-cart cart-total-row-cart">
                      <span>Total à payer</span>
                      <strong>{formatFCFA(grandTotal)} FCFA</strong>
                    </div>

                    {renderReceptionForm()}

                    <CashPayCheckout
                      amount={grandTotal}
                      description="Paiement facture"
                      disabled={isDisabled}
                      selectedPay={selectedPay}
                      setSelectedPay={setSelectedPay}
                    />

                    {selectedPay === "caisse" ? <Caisse /> : null}
                    {selectedPay === "cashpay" ? <CaisseP /> : null}

                    <button
                      className="cart-checkout-cart"
                      disabled={isDisabled}
                      onClick={handleConfirmNC}
                      onMouseEnter={() => !isDisabled && setIsHover(true)}
                      onMouseLeave={() => setIsHover(false)}
                      style={{
                        background: isDisabled ? "#ccc" : isHover ? "#219150" : "#27ae60",
                        color: "#fff",
                        opacity: isDisabled ? 0.6 : 1,
                        cursor: isDisabled ? "not-allowed" : "pointer",
                        transition: "all 0.2s ease",
                      }}
                    >
                      {selectedPay === "caisse"
                        ? "Enregistrer la commande"
                        : "Payez ma commande"}
                    </button>
                  </div>
                </aside>
              ))}
          </div>
        ) : (
          <section className="booking-wrap-scs">
            <div className="left-col-scs">
              <div className="status-card-scs">
                <div className="status-row-scs">
                  <span className="status-icon-scs" aria-hidden="true">
                    ✔
                  </span>
                  <h2 className="status-title-scs">Merci pour votre commande!!!</h2>
                </div>

                <div className="pro-row-scs">
                  <div className="pro-text-scs">
                    <p>
                      Votre commande a été bien placée sur Dollar Store. Un membre de notre
                      équipe vous contactera prochainement pour la suite. Merci de votre
                      confiance !
                    </p>

                    <br />
                    <div style={{ width: "100%", fontFamily: "Arial, sans-serif" }}>
                    <h3
                      style={{
                        margin: "0 0 10px 0",
                        fontSize: "28px",
                        fontWeight: "700",
                        color: "#4a4a4a",
                        textAlign:'left'
                      }}
                    >
                      Comment Payer?
                    </h3>

                    <div
                      style={{
                        border: "2px solid #27ae60",
                        borderRadius: "8px",
                        padding: "18px 20px",
                        display: "flex",
                        justifyContent: "space-between",
                        alignItems: "center",
                        backgroundColor: "#fff",
                        flexWrap: "wrap",
                        gap: "16px",
                      }}
                    >
                      <div style={{ flex: "1 1 300px" }}>
                        <div
                          style={{
                            fontSize: "24px",
                            fontWeight: "700",
                            color: "#4a4a4a",
                            marginBottom: "6px",
                            textAlign:'left'
                          }}
                        >
                          Mixx by Yas / FLOOZ / MOOV MONEY
                        </div>

                        <div
                          style={{
                            fontSize: "22px",
                            fontWeight: "500",
                            color: "#4a4a4a",
                            marginBottom: "10px",
                          }}
                        >
                          
                        </div>

                        <div
                          style={{
                            fontSize: "18px",
                            color: "#dc3545",
                            lineHeight: "1.5",
                            textAlign:'left'
                          }}
                        >
                          Envoyer une capture du numéro de commande pour choisir le canal par lequel , vous voulez payez.
                        </div>
                      </div>

                     
                    </div>
                  </div>
                    <br />

                    <div className="schedule-scs">
                      {getOption === "boutique" && (
                        <>
                          <span className="schedule-note-scs">Nos heures d'ouverture</span>
                          <span className="schedule-time-scs">
                            Lundi à Samedi : 08h00 - 21h00
                          </span>
                          <span className="schedule-time-scs">Dimanche : 11h00 - 20h00</span>
                        </>
                      )}

                      {getOption === "livraison" && (
                        <>
                          <span className="schedule-note-scs">Nos heures de livraison</span>
                          <span className="schedule-time-scs">
                            Lundi à Samedi : 10h00 - 18h00
                          </span>
                        </>
                      )}

                      {getOption === "expedition" && (
                        <>
                          <span className="schedule-note-scs">Nos heures d'expédition</span>
                          <span className="schedule-time-scs">
                            Lundi à Samedi : 08h00 - 21h00
                          </span>
                        </>
                      )}
                    </div>
                  </div>
                </div>
              </div>

              <button className="list-item-scs">
                <div className="list-text-scs">
                  <strong>Pour les livraisons</strong>
                  <span>
                    Vous devez payer le montant total par Tmoney, Flooz avant que le livreur
                    ne commence la livraison... Merci
                  </span>
                </div>
                <span className="chev-scs" aria-hidden="true">
                  ›
                </span>
              </button>

              <div className="help-card-scs">
                <strong>Contactez Nous ?</strong>
                <p>Contactez nous pour un traitement plus rapide de votre commande.</p>
                <br />
                <a
                  className="pay-btn-scs"
                  style={{ textDecoration: "none" }}
                  href="https://wa.me/+22890045926"
                >
                  <FaWhatsapp size={20} /> +228 90 04 59 26
                </a>
              </div>
            </div>

            <aside className="summary-card-scs">
              <img src="/images/cart.gif" alt="success" style={{ width: "100%" }} />
              <h3 className="summary-title-scs">N° Commande: #{getCommande}</h3>

              <dl className="summary-list-scs">
                <div className="row-scs">
                  <dt>Total</dt>
                  <dd>{formatFCFA(getPrice)} FCFA</dd>
                </div>

                {getOption === "livraison" && (
                  <div className="row-scs">
                    <dt>Livraison</dt>
                    <dd>{formatFCFA(getOptionPrice)} FCFA</dd>
                  </div>
                )}

                {getOption === "expedition" && (
                  <div className="row-scs">
                    <dt>Expédition</dt>
                    <dd>{formatFCFA(getOptionPrice)} FCFA</dd>
                  </div>
                )}
              </dl>

              <div className="amount-row-scs">
                <span>Total à Payer</span>
                <strong className="amount-scs">{formatFCFA(getRealPrice)} FCFA</strong>
              </div>

              <button className="pay-btn-scs" onClick={() => navigate("/products")}>
                Continuer les achats
              </button>
            </aside>
          </section>
        )}
      </section>

      <Login
        isOpen={authModal === "login"}
        onClose={closeAuthModal}
        onSwitch={switchToAuthModal}
      />

      <Register
        isOpen={authModal === "register"}
        onClose={closeAuthModal}
        onSwitch={switchToAuthModal}
      />

      <ConfirmCommand
        isOpen={openConfirm}
        onClose={() => setOpenConfirm(false)}
        onConfirm={() => createAndPayOrder(false)}
      />

      <NoLogin
        isOpen={openConfirmNC}
        onClose={() => setOpenConfirmNC(false)}
        onConfirm={() => createAndPayOrder(true)}
      />

      <LoadingOverlay show={loadingOverlay} />

      <ImageModal
        open={openImage}
        src={sourceImage}
        alt="Image produit"
        onClose={() => setOpenImage(false)}
      />

      <LocationFeeModal openD={openD} onClose={() => setOpenD(false)} />
      <PaymentHandle isOpen={showPaye} />

      <Footer />
    </>
  );
}